'use strict';

var _url = require('./url.config');

var _url2 = _interopRequireDefault(_url);

var _environments = require('../environments');

var _environments2 = _interopRequireDefault(_environments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var env = _environments2.default.get();

module.exports = _url2.default.getConfig(env);


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/config/index.js
// module id = 11
// module chunks = 0